<script setup>

//Props
defineProps({
  tag: {
    type: String,
    default: 'div',
  },
  text: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <component
    :is="tag"
    :class="$style.heading"
    hide-empty
  >
    <slot>{{ text }}</slot>
  </component>
</template>

<style module>
.heading {
  margin: 0.5rem 0 1rem;
  line-height: var(--line-height-secondary-heading);
  font-size: var(--font-size-secondary-heading);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
</style>
